<div class="container tag-highlight-wrapper">
    <lib-tag-highlight
    *ngIf="data"
    [data]="data">
    </lib-tag-highlight>
</div>